ACC.learnerlogin = {

    _autoload: [
        'bindSubmitLink',
        'bindRegistrationSubmitLink',
        'bindGuestCheckoutSubmitLink',
        'bindGuestRegistrationSubmitLink',
    ],

    signIn(username, password, rememberMe, originalReferer, successMessage, orderGUID) {
        if (ACC.config.isSsoEnabled === 'true') {
            // eslint-disable-next-line max-len
            ACC.learnerlogin.signInWithSso(username, password, rememberMe, originalReferer, successMessage, orderGUID);
        } else {
            // eslint-disable-next-line max-len
            ACC.learnerlogin.signInWithoutSso(username, password, rememberMe, originalReferer, successMessage, orderGUID);
        }
    },

    signInWithSso(username, password, rememberMe, originalReferer, successMessage, orderGUID) {
        function onSuccess(jqXHR) {
            $.ajax({
                async: false,
                type: 'POST',
                url: `${ACC.config.encodedContextPath}/login/setToken`,
                data: { username, password },
            });
            if (orderGUID) {
                $.ajax({
                    type: 'POST',
                    url: `${ACC.config.encodedContextPath}/login/order/link`,
                    data: { userId: jqXHR.data.userId, orderGUID },
                });
            }
            if (jqXHR.mock && piSession.Mock) {
                console.warn('Mock piSession usage');
                piSession.mockInitialize(jqXHR.data);
            }
        }

        function onError(jqXHR) {
            $('#pearsonLoginForm').find(':submit').prop('disabled', false);
            let messageKey;
            let attributes;
            if (jqXHR.status === 401) {
                messageKey = `account.error.${jqXHR.responseJSON.fault.detail.errorcode}`;
                if (messageKey === 'account.error.piui.generatedPasswordUserAuthFailure') {
                    attributes = [`${ACC.config.encodedContextPath}/login/pw/reset`];
                }
                ACC.learnerlogin.callGlobalMessage(messageKey, attributes);
            } else if (jqXHR.status === 403) {
                const escrowTicket = jqXHR.responseJSON.message;
                ACC.learnerconsents.showSsoAcceptConsents(
                    // eslint-disable-next-line max-len
                    () => ACC.learnerconsents.loadSsoAcceptConsents(username, password, escrowTicket, rememberMe, originalReferer, successMessage, orderGUID),
                    // eslint-disable-next-line max-len
                    () => ACC.learnerconsents.acceptConsents(username, password, escrowTicket, rememberMe, originalReferer, successMessage, orderGUID),
                    username,
                );
            } else {
                messageKey = 'account.error.generic';
                ACC.learnerlogin.callGlobalMessage(messageKey);
            }
        }

        // eslint-disable-next-line max-len
        ACC.iamActions.triggerIamLoginFromEmbeddedPage(username, password, rememberMe, originalReferer, successMessage, onSuccess, onError);
    },

    signInWithoutSso(username, password, rememberMe, originalReferer, successMessage, orderGUID) {
        // eslint-disable-next-line no-param-reassign
        orderGUID = orderGUID || '';
        ACC.forms.createAndSubmitForm(`${ACC.config.encodedContextPath}/login/signin`, {
            username,
            password,
            rememberMe,
            loginReferer: originalReferer,
            successMessage,
            orderGUID,
            formURL: window.location.href,
            CSRFToken: ACC.config.CSRFToken,
        });
    },

    bindSubmitLink() {
        $(document).on('submit', '#pearsonLoginForm', (e) => {
            e.preventDefault();
            $('#pearsonLoginForm').find(':submit').prop('disabled', true);

            ACC.globalmessages.removeGlobalMessages();

            const referer = $('#loginReferer').val() || document.referrer;

            // eslint-disable-next-line max-len
            ACC.learnerlogin.signIn($('#username').val(), $('#password').val(), $('#rememberMeLogin').is(':checked'), referer, 'account.success.login', $('#orderGUID').val());
        });
    },

    handleRegistration(url, formData, uid, password, rememberMe, referer, successMessage) {
        $.ajax({
            type: 'POST',
            url,
            data: formData, // serializes the form's elements.
            success() {
                ACC.learnerlogin.signIn(uid, password, rememberMe, referer, successMessage);
            },
            error(jqXHR) {
                console.log(jqXHR);

                if (jqXHR.responseJSON === 'register.user.exists.error') {
                    $('#username').val(uid);
                }

                const globalMessageRequest = {
                    globalMessages: [{
                        messageHolder: 'accErrorMsgs',
                        messages: [jqXHR.responseJSON],
                    }],
                };
                ACC.globalmessages.createGlobalMessage(globalMessageRequest);

                if ($('[data-recaptcha-control="getRegisterInvisibleRecaptcha"]').length) {
                    // eslint-disable-next-line no-undef
                    grecaptcha.reset();
                }
            },
        });
    },

    bindGuestRegistrationSubmitLink() {
        $(document).on('submit', '#pearsonGuestRegisterForm', function (e) {
            e.preventDefault(); // avoid to execute the actual submit of the form.

            ACC.globalmessages.removeGlobalMessages();

            const form = $(this);
            const url = form.attr('action');

            // eslint-disable-next-line max-len
            ACC.learnerlogin.handleRegistration(url, form.serialize(), $('#uid').val(), $('#password').val(), $('#rememberMe').is(':checked'), $('#referer').val(), 'registration.confirmation.message.title');
        });
    },

    bindRegistrationSubmitLink() {
        $(document).on('submit', '#pearsonRegistrationForm', (e) => {
            e.preventDefault(); // avoid to execute the actual submit of the form.

            if ($('[data-recaptcha-control="getRegisterInvisibleRecaptcha"]').length) {
                // eslint-disable-next-line no-undef
                grecaptcha.execute(); // invoke the reCAPTCHA check.
            } else {
                ACC.learnerlogin.callHandleRegistration();
            }
        });
    },

    bindGuestCheckoutSubmitLink() {
        $(document).on('submit', '#guestForm', (e) => {
            e.preventDefault();

            if ($('[data-recaptcha-control="getGuestCheckoutInvisibleRecaptcha"]').length) {
                // eslint-disable-next-line no-undef
                grecaptcha.reset();
                // eslint-disable-next-line no-undef
                grecaptcha.execute();
            } else {
                ACC.learnerlogin.callHandleGuestCheckout();
            }
        });
    },

    callHandleRegistration() {
        const form = $('#pearsonRegistrationForm');

        ACC.globalmessages.removeGlobalMessages();

        const url = form.attr('action');
        const referer = $('#loginReferer').val() || document.referrer;

        // eslint-disable-next-line max-len
        ACC.learnerlogin.handleRegistration(url, form.serialize(), $('#userID').val(), $('#passwordID').val(), $('#rememberMeRegistration').is(':checked'), referer, 'registration.confirmation.message.title', $());
    },

    callHandleGuestCheckout() {
        document.getElementById('guestForm').submit();
    },

    callGlobalMessage(messageKey, attributes) {
        const globalMessageRequest = {
            globalMessages: [{
                messageHolder: 'accErrorMsgs',
                messages: [messageKey],
                attributes,
            }],
        };
        ACC.globalmessages.createGlobalMessage(globalMessageRequest);
    },
};

// eslint-disable-next-line no-unused-vars
const recaptchBindRegistrationSubmitCallback = function () {
    ACC.learnerlogin.callHandleRegistration();
};

// eslint-disable-next-line no-unused-vars
const recaptchBindGuestCheckoutSubmitCallback = function () {
    ACC.learnerlogin.callHandleGuestCheckout();
};
